import IMapFitBounds from '../../types/IMapFitBoundsParams';

const listenToFitBoundsCompletedIfNeeded = (params: IMapFitBounds): void => {
  const { gmap, idleCallback } = params;

  if (!idleCallback) return;

  google.maps.event.addListenerOnce(gmap, 'idle', () => {
    idleCallback();
  });
};
const fitBounds = (params: IMapFitBounds) => {
  const { mapRef, padding, bounds } = params;

  mapRef.value.fitBounds(bounds, padding);
  listenToFitBoundsCompletedIfNeeded(params);
};
export default fitBounds;
